<template>
    <div class="row" :data-expand="isExpand ? true : null">
        <div class="cells" v-on:click="toggleExpand()">
            <span class="cell" data-size="status" data-align="center">
                <span class="icon-status" :data-icon="histItem.userNm == 'System' ? 'system' : 'user'" :title="histItem.userNm == 'System' ? 'System' : 'User'">System</span>
            </span>
            <span class="cell" data-size="date">
                <time datetime="">{{convertUtcTimezoneToLocal(histItem.timeLine)}}</time>
            </span>
            <span class="cell" data-size="type">
                {{ $t('AUDIT.FILTER.RULE')}}
            </span>
            <span class="cell" data-size="user">
                {{histItem.userNm}}
            </span>
            <span class="cell">
                {{$t('AUDIT.LABEL.CASE.MODIFY')}}<!--수정-->&nbsp;:&nbsp;<a href="#">{{histItem.prgrSetNm}}</a>
            </span>
            <span class="cell" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" :data-expand="isExpand ? true : null">collapse / expand</button>
            </span>
        </div>

        <div class="expand-container">
            <div-loading v-if="isExpand && bfRuleInfo == null"></div-loading>
            <!-- inner tables -->
            <table class="tbl-inner" v-if="bfRuleInfo !== null">
                <caption>{{ $t('AUDIT.LABEL.CASE.CREATE_COPY_DELETE_RULE')}}</caption>
                <colgroup>
                    <col style="width: 80px;">
                    <col style="width: 105px;">
                </colgroup>
                <thead>
                <tr>
                    <th colspan="2" scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.FROM')}}<!--변경 전--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.TO')}}<!--변경 후--></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th colspan="2">{{ $t('AUDIT.RULE.NAME')}}<!--이름--></th>
                    <td>{{bfRuleInfo.titl}}</td>
                    <td v-if="chkDiffTitl"><ins>{{afRuleInfo.titl}}</ins></td>
                    <td v-else>{{afRuleInfo.titl}}</td>
                </tr>
                <tr>
                    <th colspan="2">{{ $t('AUDIT.RULE.DESCRIPTION')}}<!--설명--></th>
                    <td>{{bfRuleInfo.desc}}</td>
                    <td v-if="chkDiffDesc"><ins>{{afRuleInfo.desc}}</ins></td>
                    <td v-else>{{afRuleInfo.desc}}</td>
                </tr>
                <tr>
                    <th colspan="2">{{ $t('AUDIT.RULE.CATEGORY')}}<!--카테고리--></th>
                    <td>
                        <span v-for="(label, idx) of bfRuleInfo.ctgLabel" class="item" :key="idx">{{getCategoryLabel(label)}}</span>
                    </td>
                    <td>
                        <span v-for="(label, idx) of afRuleInfo.ctgLabel" class="item" :key="idx">
                            <template v-if="chkDiffCategoryList"><ins>{{getCategoryLabel(label)}}</ins></template>
                            <template v-else>{{getCategoryLabel(label)}}</template>
                        </span>
                    </td>
                </tr>
                <tr>
                    <th colspan="2">{{ $t('AUDIT.RULE.SEVERITY')}}<!--심각도--></th>
                    <td>{{ $t('LABEL.SVRTY.' + bfRuleInfo.svrty)}}</td>
                    <td v-if="chkDiffSeverity"><ins>{{ $t('LABEL.SVRTY.' + afRuleInfo.svrty)}}</ins></td>
                    <td v-else>{{ $t('LABEL.SVRTY.' + afRuleInfo.svrty)}}</td>
                </tr>
                <tr>
                    <th :rowspan="getBfRuleActionNotNullFlag && getAfRuleActionNotNullFlag ? 2 : 1">Rule</th>
                    <th>Condition</th>
                    <td>
                        <p v-for="(condition, idx) of bfRuleInfo.cndVal" :key="idx">
                            <template v-for="template of templateList">
                                <!-- ID 맞는 template 찾았으면 -->
                                <template v-if="condition.tmpltId == template.tmpltId">
                                    {{ condition.cjt != 'null' && condition.cjt != null ?$t('COMMON.CONJUNCTION.' + condition.cjt) : '' }}
                                    <template v-for="lang of template[$i18n.locale].lang">
                                        <template v-if="lang['key'] === 'text'">
                                            {{ lang["val"] }}
                                        </template>

                                        <template v-if="lang['key'] === 'input-select'">
                                            <strong>
                                                {{condition.cnd.prpts[lang['val']].val}}

                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }}
                                                        </template>
                                                    </template>
                                                </template>
                                            </strong>
                                        </template>

                                        <template v-if="lang['key'] === 'input'">
                                            <strong>
                                                {{condition.cnd.prpts[lang['val']].val}}
                                            </strong>
                                        </template>


                                        <template v-if="lang['key'] === 'multi-select'">
                                            <strong>
                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }} ,
                                                        </template>
                                                    </template>
                                                </template>
                                            </strong>
                                        </template>

                                        <!-- select 여도 배열로 저장하기때문에 multiple 속성이 있음 -->
                                        <template v-if="lang['key'] === 'select'">
                                            <strong>
                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }}
                                                        </template>
                                                    </template>
                                                </template>
                                            </strong>
                                        </template>

                                    </template>
                                </template>
                            </template>
                        </p>
                    </td>
                    <td>
                        <p v-for="(condition, idx) of afRuleInfo.cndVal" :key="idx">
                            <template v-for="template of templateList">
                                <!-- ID 맞는 template 찾았으면 -->
                                <template v-if="condition.tmpltId == template.tmpltId">
                                    {{ condition.cjt != 'null' && condition.cjt != null ?$t('COMMON.CONJUNCTION.' + condition.cjt) : '' }}
                                    <template v-for="lang of template[$i18n.locale].lang">
                                        <template v-if="lang['key'] === 'text'">
                                            {{ lang["val"] }}
                                        </template>

                                        <template v-if="lang['key'] === 'input-select'">
                                            <strong>
                                                {{condition.cnd.prpts[lang['val']].val}}

                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }}
                                                        </template>
                                                    </template>
                                                </template>
                                            </strong>
                                        </template>

                                        <template v-if="lang['key'] === 'input'">
                                            <strong>
                                                {{condition.cnd.prpts[lang['val']].val}}
                                            </strong>
                                        </template>


                                        <template v-if="lang['key'] === 'multi-select'">
                                            <strong>
                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }} ,
                                                        </template>
                                                    </template>
                                                </template>
                                            </strong>
                                        </template>

                                        <!-- select 여도 배열로 저장하기때문에 multiple 속성이 있음 -->
                                        <template v-if="lang['key'] === 'select'">
                                            <strong>
                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }}
                                                        </template>
                                                    </template>
                                                </template>
                                            </strong>
                                        </template>

                                    </template>
                                </template>
                            </template>
                        </p>
                    </td>
                </tr>
                <tr  v-if="getBfRuleActionNotNullFlag && getAfRuleActionNotNullFlag">
                    <th>Action</th>
                    <td>
                        <p v-for="(actn, actnIdx) of bfRuleInfo.actnVal" :key="actnIdx">
                            <template v-for="(actnTmplt, tmplIdx) of actnTmpltList">
                                <div v-if="actnTmplt.actnId == actn.actnId" :key="tmplIdx">
                                    <span class="item">{{ $t('POLICY.RULE.ACTION.'+actnTmplt.titl)}}</span>
                                    <span class="item">{Username}, {Username}, {Username}</span>
                                </div>
                            </template>
                        </p>

                        <p>
                            <label v-if="bfRuleInfo.actnExeYn == 'Y'">{{ $t('POLICY.RULE.ACTION_EXECUTION')}}</label>
                        </p>
                    </td>
                    <td>
                        <p v-for="(actn, actnIdx) of afRuleInfo.actnVal" :key="actnIdx">
                            <template v-for="(actnTmplt, tmplIdx) of actnTmpltList">
                                <div v-if="actnTmplt.actnId == actn.actnId" :key="tmplIdx">
                                    <span class="item">{{ $t('POLICY.RULE.ACTION.'+actnTmplt.titl)}}</span>
                                    <span class="item">{Username}, {Username}, {Username}</span>
                                </div>
                            </template>
                        </p>

                        <p>
                            <label v-if="afRuleInfo.actnExeYn == 'Y'">{{ $t('POLICY.RULE.ACTION_EXECUTION')}}</label>
                        </p>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'ExpandRuleModify',
        props: ['histItem', 'ctgList', 'actnTmpltList'],
        data: function() {
          return {
              bfRuleInfo: null,
              afRuleInfo: null,
              isExpand: false
          }
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getLocale: function() {
                return this.$i18n.locale
            },
            templateList: function() {
                return this.$store.state.templateList
            },
            getBfRuleActionNotNullFlag: function() {

                if(this.bfRuleInfo == null){
                    return false
                }
                let isExist = false

                _.forEach(this.bfRuleInfo.actnVal, function(actn) {
                    if (actn.actnId !== null) {
                        isExist = true
                        return false
                    }
                })

                return isExist
            },
            getAfRuleActionNotNullFlag: function() {

                if(this.afRuleInfo == null){
                    return false
                }
                let isExist = false

                _.forEach(this.afRuleInfo.actnVal, function(actn) {
                    if (actn.actnId !== null) {
                        isExist = true
                        return false
                    }
                })

                return isExist
            },
            chkDiffTitl: function() {
                return this.bfRuleInfo.titl !== this.afRuleInfo.titl
            },
            chkDiffDesc: function() {
                return this.bfRuleInfo.desc !== this.afRuleInfo.desc
            },
            chkDiffCategoryList: function() {
                return this.bfRuleInfo.ctgLabel.length !== this.afRuleInfo.ctgLabel.length
            },
            chkDiffSeverity: function() {
                return this.bfRuleInfo.svrty !== this.afRuleInfo.svrty
            }
        },
        methods: {
            selectGovernanceRuleInfo() {

                const url = `/api/governance/audit/expand/rule/list`

                let ruleData = {
                    'cmpnId': this.curCmpnId,
                    'arrRvsnId': [this.histItem.bfRvsnId, this.histItem.afRvsnId]
                }
                this.http.post(url, ruleData)
                    .then((result) => {
                        if(result.data.status == 'ok') {
                            // for 에서 text 를 json 으로 parse
                            let bfRule = _.head(_.filter(result.data.result, { 'rvsnId' : this.histItem.bfRvsnId}));
                            let afRule = _.head(_.filter(result.data.result, { 'rvsnId' : this.histItem.afRvsnId}));
                            this.bfRuleInfo = typeof(bfRule) !== 'undefined' ? this.jsonParse(bfRule) : []
                            this.afRuleInfo = typeof(afRule) !== 'undefined' ? this.jsonParse(afRule) : []

                        } else {
                            // TODO :: Error 처리
                        }
                    }).catch(error => {
                    // TODO :: Error 처리
                });
            },
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            toggleExpand: function(){
                this.isExpand = !this.isExpand
                this.isExpand && this.bfRuleInfo == null ? this.selectGovernanceRuleInfo() : false

            },
            // CategoryList 에서 Category ID 로 Category Label 찾기
            getCategoryLabel(ctgId) {
                var categoryLabel = ''
                for(var ctg of this.ctgList) {
                    if(ctg.ctgId == ctgId) {
                        categoryLabel = ctg.ctgLabel
                    }
                }
                return categoryLabel
            },
            jsonParse: function(rule) {

                rule.cndVal = JSON.parse(rule.cndVal)
                rule.actnVal = JSON.parse(rule.actnVal)
                rule.ctgLabel = JSON.parse(rule.ctgLabel)

                return rule

            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/audit/expand/ruleModify.vue